<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="ItemID"
      :label="StockTrfItemCatalog.DispatchName.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="StockTrfItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Qty"
      :label="StockTrfItemCatalog.Qty.Label"
    >
      <kst-value multi-value :field="column.field" :data="row" :catalog="StockTrfItemCatalog">
        <kst-value multi-value field="PackagingName" :data="row" :catalog="StockTrfItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-hpptotal"
      field="HppTotal"
      :label="StockTrfItemCatalog.HppTotal.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="StockTrfItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import StockTrfItemCatalog from "../StockTrfItemCatalog.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    StockTrfItemCatalog: StockTrfItemCatalog
  })
}
</script>